<template>
    <div class="header">
      <img src="../assets/Logo w Body.png" width="300px" />
      <a class="link pr-1" href="https://aawaaz.co">Website</a>
    </div>
</template>

<script>
export default {};
</script>

<style scoped>
.header {
  display: flex;
  background: #f4f0ec;
  /* flex-direction: column; */
  align-items:center;
  justify-content: space-between;
  padding: 1rem 1.3rem;
}

.link {
  color: #ff9048;
}

.pr-1 {
  /* margin-right: rem; */
}
</style>